import { render, staticRenderFns } from "./addOrgaInfo.vue?vue&type=template&id=10d24886&scoped=true"
import script from "./addOrgaInfo.vue?vue&type=script&lang=js"
export * from "./addOrgaInfo.vue?vue&type=script&lang=js"
import style0 from "./addOrgaInfo.vue?vue&type=style&index=0&id=10d24886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d24886",
  null
  
)

export default component.exports